/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/fragments-delivery-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/fragments-delivery-api-client";
import type { FragmentsDeliveryAPIClientEnableDeliveryMutationRequest, FragmentsDeliveryAPIClientEnableDeliveryMutationResponse, FragmentsDeliveryAPIClientEnableDeliveryPathParams, FragmentsDeliveryAPIClientEnableDelivery404 } from "../models/FragmentsDeliveryAPIClientEnableDelivery";
import type { UseMutationOptions, QueryClient } from "@tanstack/react-query";
import { fragmentsDeliveryAPIClientEnableDelivery } from "../axios/fragmentsDeliveryAPIClientEnableDelivery";
import { useMutation } from "@tanstack/react-query";

export const fragmentsDeliveryAPIClientEnableDeliveryMutationKey = () => ["fragments-delivery-api", { url: '/delivery/:fragmentId/enable' }] as const

export type FragmentsDeliveryAPIClientEnableDeliveryMutationKey = ReturnType<typeof fragmentsDeliveryAPIClientEnableDeliveryMutationKey>

/**
 * @description Enables delivery for a fragment and triggers delivery jobs for its existing assets
 * @summary Enable delivery for an existing fragment
 * {@link /delivery/:fragmentId/enable}
 */
export function useFragmentsDeliveryAPIClientEnableDelivery<TContext>(options: 
{
  mutation?: UseMutationOptions<FragmentsDeliveryAPIClientEnableDeliveryMutationResponse, ResponseErrorConfig<FragmentsDeliveryAPIClientEnableDelivery404>, {fragmentId: FragmentsDeliveryAPIClientEnableDeliveryPathParams["fragmentId"], data?: FragmentsDeliveryAPIClientEnableDeliveryMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<FragmentsDeliveryAPIClientEnableDeliveryMutationRequest>> & { client?: typeof fetch },
}
 = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? fragmentsDeliveryAPIClientEnableDeliveryMutationKey()

  return useMutation<FragmentsDeliveryAPIClientEnableDeliveryMutationResponse, ResponseErrorConfig<FragmentsDeliveryAPIClientEnableDelivery404>, {fragmentId: FragmentsDeliveryAPIClientEnableDeliveryPathParams["fragmentId"], data?: FragmentsDeliveryAPIClientEnableDeliveryMutationRequest}, TContext>({
    mutationFn: async({ fragmentId, data }) => {
      return fragmentsDeliveryAPIClientEnableDelivery(fragmentId, data, config)
    },
    mutationKey,
    ...mutationOptions
  }, queryClient)
}